import React from "react";
import { iconFor, formatTitle, formatField } from "../utils/formatting";

export default function SubcollectionSection({ subName, item, type, parentUseCaseId }) {
  if (!item) return null;

  const firstFieldValue = Object.values(item)[0];
  const title =
      item.title ||
      item.name ||
      item.type ||
      (typeof firstFieldValue === "string" ? firstFieldValue : "Untitled");
  const description = item.description || "";

  const docRoute = `/useCases/flows/${item.flowName}`

  // Define Field Map of the exact fields we want to appear
  const FIELD_MAP = {
    object: [
      // { field: "title", label: "" },
      { field: "description", label: ""},
      { field: "relationships", label: "Relationships" }
    ],
    flow: [
      // { field: "title", label: "" },
      { field: "summary", label: "" },
      { field: "Process Type", label: "Type" }
    ]
  };


  const fieldsToShow = FIELD_MAP[type] || [];

  return (
    <section className="subcollectionSection">
      <div className="cardGrid">
        <div className={`objectCard card-${subName.toLowerCase()}`}>
          <div className="cardTitle">
            <h3>{iconFor(subName)}{title}</h3>
            {description && (
              <p className="cardDescription">{description}</p>
            )}
          </div>

          {/* Render only whitelisted fields with fieldsToShow.map*/}
          <div className="cardFields">
            {fieldsToShow.map(({ field, label}) => {
              const value = item[field];
              if (!value) return null;

              return (
                <p key={field} className="cardField">
                  {label && <strong>{label}: </strong>}
                  {Array.isArray(value) ? value.join(", ") : String(value)}
                </p>
              );
            })}

            {type === "flow" && item.docRoute && (
              <a
                href={`${docRoute}?parent=${encodeURIComponent(parentUseCaseId)}`}
                className="viewLink"
              >
                View Documentation →
              </a>
            )}
          </div>
        </div>
      </div>

    </section>
  );
}
